import { FetchResult, NormalizedCacheObject } from 'apollo-boost';
import { get } from 'lodash';

import { deleteCallouts, saveCallouts } from '../../graphql/mutations/grid/callout';
import { ApiMethodExecutingError } from '../../service/Errors';
import { DeleteCallouts, GdDeleteCalloutsInput, GdSaveCalloutsInput, SaveCallouts } from '../../typings/graphql-grid';
import { DNAApolloClient } from '../DNAApolloClient/DNAApolloClient';

export class CalloutsMutation {
    constructor(private client: DNAApolloClient<NormalizedCacheObject>) {}

    public async addCallouts(input: GdSaveCalloutsInput): Promise<SaveCallouts> {
        const response: FetchResult<SaveCallouts> = await this.client.mutate<SaveCallouts>({
            mutation: saveCallouts,
            variables: {
                input: input
            }
        });

        if (
            (!response.errors || response.errors.length === 0) &&
            (response.data && !response.data.saveCallouts.validationResult)
        ) {
            return response.data;
        } else {
            const validationResult = get(response, 'data.saveCallouts.validationResult', { errors: [], warnings: [] });
            throw new ApiMethodExecutingError({
                message: 'Add callout error',
                errors: validationResult.errors,
                warnings: validationResult.warnings
            });
        }
    }

    public async deleteCallouts(input: GdDeleteCalloutsInput): Promise<DeleteCallouts> {
        const response: FetchResult<DeleteCallouts> = await this.client.mutate<DeleteCallouts>({
            mutation: deleteCallouts,
            variables: {
                input: input
            }
        });

        if (
            (!response.errors || response.errors.length === 0) &&
            (response.data && !response.data.deleteCallouts.validationResult)
        ) {
            return response.data;
        } else {
            const validationResult = get(response, 'data.deleteCallouts.validationResult', {
                errors: [],
                warnings: []
            });
            throw new ApiMethodExecutingError({
                message: 'Delete callout error',
                errors: validationResult.errors,
                warnings: validationResult.warnings
            });
        }
    }
}
